<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="mode === 'edit' ? 'Edit Vendor' : 'Add Vendor'"
      [canGoBack]="true"
      [noBow]="true"
      [showLinkIcon]="mode === 'edit'"
      [linkIcon]="'trash'"
      (linkAction)="boundDelete()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form" novalidate>
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
      @if (loaded) {
        <tidy-card>
          <tidy-row>
            <tidy-text [header]="'Vendor Info'" />
          </tidy-row>
          <tidy-select
            [label]="'Category'"
            formControlName="vendor_category_id"
            [form]="form.controls.vendor_category_id"
            [items]="categoryItems"
            [icon]="'assets/svg/list-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please choose a category'" />
          <tidy-input
            [label]="'Name'"
            formControlName="name"
            [form]="form.controls.name"
            [icon]="'assets/svg/person-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a name'" />
          <tidy-input
            [label]="'Company Name'"
            formControlName="company_name"
            [form]="form.controls.company_name"
            [icon]="'assets/svg/business-outline.svg'" />
          <tidy-input
            [label]="'Email'"
            formControlName="email"
            [form]="form.controls.email"
            [icon]="'assets/svg/mail-outline.svg'"
            [type]="'email'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid email'" />
          <tidy-input
            [label]="'Phone'"
            formControlName="phone"
            [form]="form.controls.phone"
            [icon]="'assets/svg/call-outline.svg'" />
        </tidy-card>

        <tidy-card>
          <tidy-row>
            <tidy-text [header]="'Address'" />
          </tidy-row>
          <tidy-input
            [label]="'Address Line 1'"
            formControlName="address1"
            [form]="form.controls.address1"
            [icon]="'assets/svg/home-outline.svg'" />
          <tidy-input
            [label]="'Address Line 2'"
            formControlName="address2"
            [form]="form.controls.address2" />
          <tidy-input
            [label]="'City'"
            formControlName="city"
            [form]="form.controls.city" />
          <tidy-input
            [label]="'State'"
            formControlName="state"
            [form]="form.controls.state" />
          <tidy-input
            [label]="'ZIP / Postal Code'"
            formControlName="zipcode"
            [form]="form.controls.zipcode" />
          <tidy-input
            [label]="'Country Code'"
            formControlName="country_code"
            [form]="form.controls.country_code" />
        </tidy-card>

        <tidy-card>
          <tidy-row>
            <tidy-text [header]="'Notes'" />
          </tidy-row>
          <tidy-textarea
            [label]="'Description'"
            formControlName="description"
            [form]="form.controls.description" />
          <tidy-textarea
            [label]="'Notes'"
            formControlName="notes"
            [form]="form.controls.notes" />
        </tidy-card>

        @if (errorMessage) {
          <tidy-error-message [text]="errorMessage" />
        }

        <tidy-button
          [text]="mode === 'edit' ? 'Save Changes' : 'Add Vendor'"
          [action]="boundSave"
          class="primary" />

        @if (mode === 'edit') {
          <tidy-row [align]="'center'" class="extra-top-padding">
            <tidy-text
              [actionBody]="'Remove Vendor'"
              (action)="boundDelete()"
              class="link red" />
          </tidy-row>
        }
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
